export {
  default as hostMembershipPlain,
  ReactComponent as HostMembershipPlain,
} from '@assets/icons/host-membership-plain.svg'
